import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import DashboardLayout from "../../layouts/DashboardLayout";
import localeText from "../../../../locale";
import StoreSettingsIntegrationsTab from "../Store/components/StoreSettingsIntegrationsTab";
import "../Store/StoreSettingsPage.css";
import "./CustomerIntegrationsStyles.css";

const CustomerIntegrationsPage = ({ userInfo }) => {
  return (
    <DashboardLayout>
      <div className="flex align-items-center gap-4">
        <div
          className="border-circle p-3"
          style={{
            border: "1px solid var(--theme-border, #EBEBEB)",
            width: "54px",
            height: "54px",
          }}
        >
          <i className="pi pi-cog text-xl" style={{ color: "var(--theme-text-muted, #5C5C5C)" }} />
        </div>
        <div>
          <h2 className="text-lg font-semibold m-0" style={{ color: "var(--theme-text)" }}>
            {localeText("integrations")}
          </h2>
          <p className="text-sm m-0 mt-1" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
            {localeText("integrationsDescription")}
          </p>
        </div>
      </div>

      <hr className="mb-0" />

      <StoreSettingsIntegrationsTab customerIntegrationsPage={true} userInfo={userInfo} allowedIntegrations={["whatsapp"]} />
    </DashboardLayout>
  );
};

export default CustomerIntegrationsPage;

